import { AuthVerificationApi } from '@arbihunter/api-client';
import { Console, Effect, pipe } from 'effect';
import { api } from 'shared/api';
import {
  AuthVerificationError,
  VerificationCodeConfirmParamsDto,
  VerificationCodeConfirmResponseDto,
  VerificationCodeSendParamsDto,
  VerificationCodeSendResponseDto,
} from './models';
export { AuthResponseDTO, AuthVerificationResponseDTO } from '@arbihunter/api-client';

export const verificationCodeSend = ({
  email,
}: VerificationCodeSendParamsDto): Effect.Effect<
  VerificationCodeSendResponseDto,
  AuthVerificationError
> =>
  pipe(
    Effect.tryPromise({
      try: async () =>
        await api.run(AuthVerificationApi).code0({ authVerificationCodeDTO: { email } }),
      catch: (error) => new Error('UNKNOWN_ERROR'),
    }),

    Effect.tap((data) => console.log('[sendVerificationCode] API call result:', data)),

    Effect.onError((error) => Console.error('[sendVerificationCode] Error occurred:')),

    Effect.map((data): VerificationCodeSendResponseDto => ({ email: data.email, code: data.code })),
  );

export const verificationCodeConfirm = ({
  email,
  code,
}: VerificationCodeConfirmParamsDto): Effect.Effect<
  VerificationCodeConfirmResponseDto,
  AuthVerificationError
> =>
  pipe(
    Effect.tryPromise(
      () =>
        api.run(AuthVerificationApi).verify0({
          authVerificationVerifyDTO: { email, code },
        }) as Promise<VerificationCodeConfirmResponseDto>,
    ),
    Effect.tap((data) => console.log('[verifyConfirmCode] API call result:', data)),
    Effect.onError((error) => Console.error('[verifyConfirmCode] Error occurred:', error)),
  );
